import {
  pageState,
  spamAssassinState,
  deliverabilityState
} from '../state/page'

import { getSpamCheck, getDeliverabilityCheck } from '../actions/actions'

import { logAppError } from 'Helpers/logger'
import getIntl from 'Helpers/intl'

export const fetchSpamAssassinCallback = ({ set, snapshot }) => async id => {
  set(spamAssassinState, prev => ({ ...prev, loading: true }))

  try {
    const spamCheck = await getSpamCheck(id)

    set(spamAssassinState, prev => ({
      ...prev,
      loading: false,
      spamCheck
    }))
  } catch (error) {
    console.error('### error', error)
    logAppError({
      appError: error
    })
    set(pageState, prev => ({
      ...prev,
      error: getIntl().formatMessage({ id: 'Load.Alerts.ErrorGeneric' }),
      severity: 'danger'
    }))
  }
}

export const fetchDeliverabilityCallback = ({ set, snapshot }) => async id => {
  set(deliverabilityState, prev => ({ ...prev, loading: true }))

  try {
    const results = await getDeliverabilityCheck(id)

    set(deliverabilityState, prev => ({
      ...prev,
      results,
      loading: false,
      firstCheck: false
    }))
  } catch (error) {
    console.error('### error', error)
    logAppError({
      appError: error
    })
    set(pageState, prev => ({
      ...prev,
      error: getIntl().formatMessage({ id: 'Load.Alerts.ErrorGeneric' }),
      severity: 'danger'
    }))
  }
}
